<template>
  <div class="tw-flex tw-gap-1 md:tw-gap-2 tw-justify-center">
    <button type="button"
      class="tw-flex tw-gap-2 tw-items-center tw-cursor-pointer tw-transition tw-duration-300 tw-ease-in-out tw-whitespace-nowrap tw-rounded-[8px] tw-px-3 tw-py-[6px] tw-border-2"
      :class="!isFlipped
        ? 'tw-bg-bgSideToggleActive tw-text-white tw-border-solYellow'
        : 'tw-bg-bgToolbar tw-text-white/70 tw-border-bgToolbar hover:tw-bg-bgSideToggleActive active:tw-bg-bgSideToggleActive/50 hover:tw-border-bgSideToggleActive active:tw-border-bgSideToggleActive/50'
        " :aria-pressed="!isFlipped" @click="$emit('select-front')">
      <span class="button-label">{{ $t("frontSide") }}</span>
      <span class="tw-w-16 lg:tw-w-[72px] tw-rounded-[4px] tw-overflow-hidden tw-flex-shrink-0 tw-block"
        :style="{ aspectRatio: canvasAspectRatio }" aria-hidden="true">
        <img v-if="frontPreviewUrl" :src="frontPreviewUrl" :alt="$t('frontSide')"
          class="tw-size-full tw-object-cover" />
      </span>
    </button>

    <button type="button"
      class="tw-flex tw-gap-2 tw-items-center tw-cursor-pointer tw-transition tw-duration-300 tw-ease-in-out tw-whitespace-nowrap tw-rounded-[8px] tw-px-3 tw-py-[6px] tw-border-2"
      :class="isFlipped
        ? 'tw-bg-bgSideToggleActive tw-text-white tw-border-solYellow'
        : 'tw-bg-bgToolbar tw-text-white/70 tw-border-bgToolbar hover:tw-bg-bgSideToggleActive active:tw-bg-bgSideToggleActive/50 hover:tw-border-bgSideToggleActive active:tw-border-bgSideToggleActive/50'
        " :aria-pressed="isFlipped" @click="$emit('select-back')">
      <span class="tw-w-16 lg:tw-w-[72px] tw-rounded-[4px] tw-overflow-hidden tw-flex-shrink-0 tw-block"
        :style="{ aspectRatio: canvasAspectRatio }" aria-hidden="true">
        <img v-if="backPreviewUrl" :src="backPreviewUrl" :alt="$t('backSide')" class="tw-size-full tw-object-cover" />
      </span>
      <span class="button-label">{{ $t("backSide") }}</span>
    </button>
  </div>
</template>

<script>
import { canvasAspectRatio } from '@/constants/canvas';

export default {
  name: 'SideToggleWithPreview',
  data() {
    return { canvasAspectRatio };
  },
  props: {
    frontPreviewUrl: {
      type: String,
      default: null,
    },
    backPreviewUrl: {
      type: String,
      default: null,
    },
    isFlipped: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-front', 'select-back'],
};
</script>

<style scoped>
.button-label {
  font-size: 10px;
  letter-spacing: 1px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;

  @media (max-width: 420px) {
    white-space: normal;
  }

  @media (min-width: 1024px) {
    font-size: 12px;
  }
}
</style>
